
const URL_PREFIX_SKIP_WIZARD_LEAVE_PROMPT = '/internal/skip-wizard-leave-prompt';

export default {
    URL_PREFIX_SKIP_WIZARD_LEAVE_PROMPT
};
